var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.338363 1.863C0.231307 1.67275 0.175942 1.45778 0.177779 1.23948C0.179615 1.02119 0.238589 0.80718 0.348831 0.618757C0.459073 0.430335 0.616738 0.274069 0.806136 0.165512C0.995534 0.056954 1.21006 -0.000109562 1.42836 1.57924e-07H6.60836C6.8745 0.000103722 7.13581 0.071011 7.36549 0.205447C7.59518 0.339882 7.78496 0.533006 7.91536 0.765L11.0004 6.258L14.0854 0.765C14.2158 0.533006 14.4055 0.339882 14.6352 0.205447C14.8649 0.071011 15.1262 0.000103722 15.3924 1.57924e-07H18.5724C18.7907 -0.000109562 19.0052 0.056954 19.1946 0.165512C19.384 0.274069 19.5417 0.430335 19.6519 0.618757C19.7621 0.80718 19.8211 1.02119 19.8229 1.23948C19.8248 1.45778 19.7694 1.67275 19.6624 1.863L11.0894 17.103C10.9806 17.2963 10.8224 17.4572 10.6309 17.5692C10.4395 17.6812 10.2217 17.7402 9.99986 17.7402C9.77806 17.7402 9.56024 17.6812 9.36878 17.5692C9.17731 17.4572 9.0191 17.2963 8.91036 17.103L0.338363 1.863Z",
    fill: "#FEDC34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.f865c170.svg";
export { ForwardRef as ReactComponent };